import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * ZoomDropdown:
 *  - Component renders the dropdown for PopupZoomImage
 */
export function ZoomDropdown(props) {
  return (
    <Dropdown
      placeholder='zoom'
      className='zoom-dropdown'
      options={props.options}
      onChange={props.onChange}
      value={props.value}
    />
  );
}

ZoomDropdown.propTypes = {
  /**
   * Function to involke when an option changes
   */
  onChange: PropTypes.func.isRequired,
  /**
   * List of options for drop down
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value for zoom option
       */
      value: PropTypes.number,
      /**
       * Lable for zoom option
       */
      label: PropTypes.string,
    })
  ),
  /**
   * current zoom value
   */
  value: PropTypes.number,
};
